import * as Sentry from '@sentry/react';
import { ACCOUNTID, CREDITCARD, TESTMODE } from '../helpers/constants';

const createPaymentToken = async (paymentType, cctoken) => {
  if (paymentType !== CREDITCARD) return { success: true, token: '' };

  try {
    const name = cctoken.name.split(' ');

    const firstName = name.shift();
    const lastName = name.pop();

    const expireAt = cctoken.expireAt.split('/');
    const month = expireAt.shift();
    const year = expireAt.pop();

    window.Iugu.setAccountID(ACCOUNTID);
    window.Iugu.setTestMode(TESTMODE);

    const creditCard = window.Iugu.CreditCard(
      cctoken.number,
      month,
      year,
      firstName,
      lastName,
      cctoken.code,
    );

    return new Promise(async (resolve) => {
      try {
        window.Iugu.createPaymentToken(creditCard, (response) => {
          if (response.errors) {
            Sentry.setContext('createPaymentTokenResponse', { response });
            Sentry.captureMessage('createPaymentToken');
            console.log('createPaymentToken', response.errors);
            resolve({
              success: false,
              token: '',
              message: 'Erro ao gerar pagamento, verifique os dados do cartão!',
            });
          } else {
            resolve({ success: true, token: response.id });
          }
        });
      } catch (error) {
        Sentry.setContext('error', { error });
        Sentry.captureMessage('createPaymentToken');
        console.log('createPaymentToken', error);
        resolve({
          success: false,
          token: '',
          message: 'Erro ao gerar pagamento, verifique os dados do cartão!',
        });
      }
    });
  } catch (error) {
    Sentry.setContext('error', { error });
    Sentry.captureMessage('createPaymentToken');
    console.log('createPaymentToken', error);
    return {
      success: false,
      token: '',
      message: 'Erro ao gerar pagamento, verifique os dados do cartão!',
    };
  }
};

export { createPaymentToken };
